/**
 * @generated SignedSource<<dfbdab2f00717e1d38ac2f235d1e87ae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueKeyCell_fields$data = {
  readonly id?: string;
  readonly isRemoteIssue?: boolean | null | undefined;
  readonly isResolved: boolean | null | undefined;
  readonly statusField: {
    readonly status: {
      readonly statusCategory: {
        readonly statusCategoryId: string;
      } | null | undefined;
    };
  } | null | undefined;
  readonly webUrl?: AGG$URL | null | undefined;
  readonly " $fragmentType": "IssueKeyCell_fields";
};
export type IssueKeyCell_fields$key = {
  readonly " $data"?: IssueKeyCell_fields$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueKeyCell_fields">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isRemoteLinkedIssuesEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "IssueKeyCell_fields",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "isResolved"
    },
    {
      "concreteType": "JiraStatusField",
      "kind": "LinkedField",
      "name": "statusField",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraStatus",
          "kind": "LinkedField",
          "name": "status",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraStatusCategory",
              "kind": "LinkedField",
              "name": "statusCategory",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "statusCategoryId"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "condition": "isRemoteLinkedIssuesEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isRemoteIssue"
        },
        {
          "kind": "ScalarField",
          "name": "webUrl"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "a1753ba360213f4a7ae012c6019ee10d";

export default node;
